import React, { useEffect } from 'react';
import Select, { components, SingleValue } from 'react-select';
import SelectBtnDrop from '/assets/icon/global/select-btn-drop.svg';
import { ptwApi } from '../../../api/ptw.api.ts';

interface Option {
  label: string;
  value: string | number;
}

interface IProps {
  options: Option[];
  label?: string;
  name?: string;
  id?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  selectWidth?: number;
  disabled?: boolean;
  readOnly?: boolean;
  error?: string;
  isClearable?: boolean;
  nullLabel?: string;
  labelWidth?: number;
}

const CustomSelectSingle = ({ labelWidth = 150, ...props }: IProps) => {
  /*useEffect(() => {
    console.log(props.selectWidth);
  }, []);*/
  const selectedOption =
    props.options.find((opt) => String(opt.value) === String(props.value ?? '')) ?? null;

  const handleChange = (opt: SingleValue<Option>) => {
    if (props.readOnly || props.disabled) {
      return;
    }

    const value = opt ? opt.value : '';

    if (props.onChange) {
      const syntheticEvent = {
        target: {
          name: props.name ?? '',
          value,
          type: 'select-one'
        }
      } as unknown as React.ChangeEvent<HTMLSelectElement>;

      props.onChange(syntheticEvent);
    }
  };

  const isDisabled = props.disabled || props.readOnly;

  const placeholder = props.nullLabel ? props.nullLabel : '- Select -';

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={SelectBtnDrop} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div
      className={`custom-select-single ${props.className || ''}`}
      style={{
        ...props.style,
        ...(props.selectWidth ? { width: props.selectWidth } : {})
      }}
      aria-readonly={props.readOnly}
    >
      {props.label && (
        <label htmlFor={props?.id} style={{ width: labelWidth }}>
          {props.label}
        </label>
      )}

      {props.name && <input type="hidden" name={props.name} value={props.value ?? ''} />}

      <Select
        inputId={props?.id}
        options={props.options}
        value={selectedOption}
        onChange={handleChange}
        isDisabled={isDisabled}
        placeholder={placeholder}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        components={{ IndicatorSeparator: () => null, DropdownIndicator }}
        menuPlacement="auto"
        /*styles={props.selectStyle}*/
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          container: (base) => ({
            ...base,
            width: '100%'
          })
        }}
        classNamePrefix="custom-select-single"
        noOptionsMessage={({ inputValue }) => (inputValue ? 'No Result' : 'No Result')}
        isClearable={props.isClearable == null ? true : props.isClearable}
      />

      {props.error && <div className="error-text">{props.error}</div>}
    </div>
  );
};

export default CustomSelectSingle;
